import { GSILoader } from "../login/direct_providers/commons/GSILoader.js";
import { AggregateStatsCollector } from "../stats/AggregateStatsCollector.js";
import { GA4StatsCollector } from "../stats/GA4StatsCollector.js";
import { NativeAppUserPropertiesPropagator } from "../stats/NativeAppUserPropertiesPropagator.js";
import { BookmarkAction, getStatDeviceTypeFromNotificationDeviceType, NewlsetterAction, TopicAction } from "../stats/UserActionTypes.js";

import { CatalogueLanguages } from "@ciaopeople/cp-shatsu/Catalogue";
import { DetectedWebView, detectWebView } from "@ciaopeople/cp-shatsu/ClientDetection";
import { DomHelper as D } from "@ciaopeople/cp-shatsu/DomHelper";
import { niceDateFormat } from '@ciaopeople/cp-shatsu/Formats';
import { Response } from "@ciaopeople/cp-shatsu/HTTP";
import { BrowserLogger, Logger } from "@ciaopeople/cp-shatsu/Logging";
import { CompletionPolicy, MergedObservable } from "@ciaopeople/cp-shatsu/Observable";
import { ClassicQueue, SimpleQueueResolver } from "@ciaopeople/cp-shatsu/Queues";
import { PostMessageProxyPromise } from "@ciaopeople/cp-shatsu/RemoteService";
import { GA4UnifiedHelper } from "@ciaopeople/cp-shatsu/Stats";
import { inEnum, isFunction } from "@ciaopeople/cp-shatsu/TypeChecking";
import { hasOwnProperty } from "@ciaopeople/cp-shatsu/Utils";
import { APIClientInterface, Ask1stPartyEmailLoginOperation } from "../api/APIClientInterface.js";
import { DataDeletionInfo } from "../api/types/AuthDataTypes.js";
import { MembershipStatusInfo } from "../api/types/MembershipStatusInfo.js";
import { FollowResponseObject, GroupedResolvedTopicObjs, RecommendedCount, RecommendedResponse, TopicFollowCheckRequest, TopicFollowCheckResponse, TopicObj, TopicQueryObj, TopicSubscriptionCheckRequest, TopicSubscriptionCheckResponse, UserActionExtraInfo } from "../api/types/NotificationDataTypes.js";
import { DeviceOrientedRequest, DeviceUpdateRequestPayload, SubscriptionListResponse } from "../api/types/SubscriptionTypes.js";
import { Ask1stPartyEmailAuthData, OnLoginResponse, OnUserUpdateData, UserFullInfo, UserGender } from "../api/types/UserDataTypes.js";
import { ThirdPartyCientAuthData, ThirdPartyCientAuthDataInterface } from "../login/data/LoginData.js";
import { PrompLoginCustomParameters } from "../login/direct_providers/LoginProvider.js";
import { getFunnelSessionId } from "../login/FunnelSessionUtils.js";
import { API_LOGIN_HASH, MembershipType } from "../membership/MembershipController.js";
import { StatsCollector } from "../stats/StatsCollector.js";



import { UserActionError, UserActionIdentifier } from "../api/commondata/UserActionError.js";
import { APIClientRemoteImpl } from "../api/impl/APIClientRemoteImpl.js";
import { EmailLoginAskResponse, FullContent } from "../api/RESTUserServices.js";
import { BookmarkCheckRequest, BookmarkCheckResponse, BookmarkedContentsResponse, BookmarkQueryObj, isBookmarkQueryByUrl } from "../api/types/BookmarkingDataTypes.js";
import { ConfigHelper } from "../config/ConfigHelper.js";
import { PropertyConfig } from "../config/PropertyConfig.js";
import { AggregateStatsLogger, GA4StatsLogger, MessagingPushNotHelperLogger } from "../logging/Loggers.js";

import { AuthProviderIdentifier } from "../login/AuthProviderIdentifier.js";
import { LoginManager } from "../login/LoginManager.js";
import { UserRole } from "../login/UserRole.js";
import { SessionObject } from "../session/SessionObject.js";
import { getUserIdFromSession, isLoggedInSession, StorableSession } from "../session/StorableSession.js";

import { FirstPartyEmailLogin } from "@api-commons/login/direct_providers/FirstPartyEmailLogin.js";

import { Action } from "@ciaopeople/cp-shatsu/EventHandler";
import { CurrentSessionProxyDefaultImpl, UpdatableSessionProxy } from "../login/CurrentSessionProxy.js";
import { OneTapDelegateLocalImpl } from "../login/direct_providers/impl/OneTapDelegateLocalImpl.js";
import { OneTapDelegate } from "../login/direct_providers/OneTapDelegate.js";
import { isProviderHasOneTapDelegate } from "../login/direct_providers/ProviderHasDelegate.js";
import { CpNativeAppUpstreamBridge, NativeAppSetSessionCause } from "../nativeapps/CpNativeAppIntegration.js";
import { CpNativeAppUpstreamBridgeImpl } from "../nativeapps/impl/CpNativeAppUpstreamBridgeImpl.js";
import { DummyCpNativeAppUpstreamBridge } from "../nativeapps/impl/DummyCpNativeAppUpstreamBridge.js";
import { NativeAppSupportedFeatures } from "../nativeapps/NativeAppSupportedFeatures.js";
import { SessionStorageRemoteImpl } from "../session/impl/SessionStorageRemoteImpl.js";
import { SNHUBLogicPublicDataRemoteImpl } from "../snhub/impl/SNHUBLogicPublicDataRemoteImpl.js";
import { SNHUBLogicPublicData } from "../snhub/SNHUBLogicPublicData.js";
import { PushNotificationService } from "../subscriptions/PushNotificationService.js";
import { PushServiceInterface } from "../subscriptions/PushServiceInterface.js";
import { DeviceIdInfo, DeviceIdProvider } from "../utils/DeviceIdProvider.js";
import { PersonalDataStorageRemoteImpl } from "../utils/impl/PersonalDataStorageRemoteImpl.js";
import { PersonalDataStorageInterface } from "../utils/PersonalDataStorageInterface.js";
import { BuyMembershipOptions, ClientSdkCorePublic, isOTPLoginInputData, OTPLoginInputData, OTPVerificationResponse } from "./ClientSdkPublicInterface.js";
import { GLOBAL_FUNCTION_NAME, QUEUE_PARAM_NAME } from "./LoaderConstants.js";
import { directLoginManagerBuilder, getGSILoader } from "./LoginManagerStarter.js";
import { ApplicationUrlHandler } from "./modules/ApplicationUrlHandler.js";
import { ApplicationUrlHandlerDefaultImpl } from "./modules/impl/ApplicationUrlHandlerDefaultImpl.js";
import sdk_version from "./version.js";
import { CTA_NAME, CTA_OUTCOME, CTAStatsDetails } from "../stats/CTATypes.js";
import { SharedGuiControls } from "../gui/SharedGuiControls.js";
import { LoginMode } from "@api-commons/login/LoginMode.js";




export abstract class AbstractClientSdk7 
    extends SimpleQueueResolver
    implements  ClientSdkCorePublic {

    protected logger: Logger;
    protected nativeLogger: Logger;
    protected detectedWebview: DetectedWebView;
    protected cfgHelper: ConfigHelper;
    protected signin_extra_params: { enable_bsim: boolean, enable_gender_sim: string };
    protected proxy: PostMessageProxyPromise;
    protected api: APIClientInterface;
    protected loginManager: LoginManager;
    protected personalDataStorage: PersonalDataStorageInterface;
    protected deviceIdProvider: DeviceIdProvider;
    protected urlHandler: ApplicationUrlHandler;
    
    protected snuLogic: SNHUBLogicPublicData;
    protected statsCollector: StatsCollector;
    protected ga4StatsCollector: GA4StatsCollector;
    //il nome di questa property non deve essere modificato; è quello che le app
    //native si aspettano in pagina
    public readonly nativeapp: CpNativeAppUpstreamBridge;
    public readonly nativeAppFeatures: NativeAppSupportedFeatures;

    protected sessionProxy: UpdatableSessionProxy;

    public successSubject: MergedObservable<any>;
    public errorSubject: MergedObservable<UserActionError>;

    protected readonly oneTapDelegate: OneTapDelegate;

    public readonly pushNotificationService: PushServiceInterface;
    private classicQueue = new ClassicQueue(window, QUEUE_PARAM_NAME);

    protected gsiLoader: GSILoader;



    abstract on(eventName: string, callback: Action): any;
    abstract one(eventName: string, callback: Action): any;
    abstract off(eventName: string, callback: Action): any;

    protected abstract getSharedGuiControls(): Promise<SharedGuiControls>; 

    constructor(
        public readonly config: PropertyConfig,
        registerServiceWorker: boolean,
        GA4AdditionalParameters
    ) {
        super();
        this.logger = new BrowserLogger("[ClientSdk-" + sdk_version+ "]", "#3C3");
        this.nativeLogger = new BrowserLogger("[NAPP]", "#33f");
        this.cfgHelper = new ConfigHelper(this.config);
        this.successSubject = new MergedObservable(CompletionPolicy.COMPLETE_ON_ALL_COMPLETE);
        this.errorSubject = new MergedObservable(CompletionPolicy.COMPLETE_ON_ALL_COMPLETE);
        
        //%% 8======D - - - - - ( . ) ( . ) -> cipisciazzu

        this.detectedWebview = detectWebView();

        

        this.signin_extra_params = {
            enable_bsim: false,
            enable_gender_sim: null
        };
        
        this.logger.log("running on site", this.config.site);
        this.nativeAppFeatures = new NativeAppSupportedFeatures(this.detectedWebview, 
            this.config.nativeApp, this.nativeLogger);
            
        // ? Questo scoppia quando non siamo in native app, quindi nel dubbio ho inserito temporaneamente un dummy 
        if (this.detectedWebview.native_app) {
            this.nativeapp = new CpNativeAppUpstreamBridgeImpl(this.nativeLogger);
        }
        else {
            this.nativeapp = new DummyCpNativeAppUpstreamBridge(this.nativeLogger);
        }
        
        

        this.serverIframe = D("<iframe>").id("fp-sdk-root").
            attr("width", "0").attr("height", "0").css({ display: "none" });

        D(document.body).append(this.serverIframe);


        this.iframeBaseUrlPart = "http" + (this.config.secure?"s":"") + "://" + this.config.host;

        this.proxy = new PostMessageProxyPromise({ },
            window,
            this.logger,
            (this.serverIframe.get(0) as HTMLIFrameElement).contentWindow,
            (origin) => origin.indexOf(this.config.host) >= 0,
            this.iframeBaseUrlPart
        );


        this.snuLogic = new SNHUBLogicPublicDataRemoteImpl(this.proxy);

           


        const ga4helper: GA4UnifiedHelper = new GA4UnifiedHelper(window,{
            accountId: config.ga4.accountId,
            applyUserId: true,
            preload: false,
            defer: true,
            trackingOptions: {
                useCookieDomain: config.ga4.cookieDomain
            }
        })
        
        const session_funnel = getFunnelSessionId();
        let useGa4Params = GA4AdditionalParameters;
        if(session_funnel && session_funnel.trim() != "") {
            useGa4Params = useGa4Params || {};
            useGa4Params['funnel_session'] = session_funnel;
        }


        this.ga4StatsCollector = new GA4StatsCollector(
                    ga4helper,
                    GA4StatsLogger,
                    useGa4Params
        );

        this.statsCollector = new AggregateStatsCollector(
            [
                this.ga4StatsCollector,
                new NativeAppUserPropertiesPropagator(this.nativeapp)
            ],
            AggregateStatsLogger
        );

        this.api = new APIClientRemoteImpl(this.proxy);

        const sessionStorage = new SessionStorageRemoteImpl(this.proxy);



        this.urlHandler = new ApplicationUrlHandlerDefaultImpl(
            this.detectedWebview,
            this.snuLogic,
            this.config.nativeApp,
            {
                servicePaths: this.cfgHelper.getServicePathsMapping(),
                secure: this.config.secure,
                host: this.config.host
            },
            this.config.membership ? this.config.membership : { enable: false }
        );

        this.gsiLoader = getGSILoader(config);

        const stproxy = new PersonalDataStorageRemoteImpl(this.proxy);
        this.personalDataStorage = stproxy;
        this.deviceIdProvider = stproxy;

        // const self = this;
        // const contextualControls: ContextualEmailLoginDialogControls = {
        //     showPersonalModal: (): Promise<Ask1stPartyEmailAuthData> => {
        //         return this.internalShowMailLoginDialog(false, UserActionIdentifier.LOGIN, {});
        //         // const email = prompt("Inserisci la tua email")
        //         // return Promise.resolve({
        //         //     email: email
        //         // });
        //     },
        //     askChallenge: function (data: Ask1stPartyEmailAuthData): Promise<EmailLoginAskResponse> {
        //         return self.api.ask1stPartyEmailLogin(Ask1stPartyEmailLoginOperation.SIGN_UP,data);
        //     },
        //     showCodeModal: (errorMessage?: string): Promise<string> => {
        //         return this.getSharedGuiControls().then(c => c.askOtp(errorMessage));
        //         // const code = prompt("Inserisci il codice di verifica inviato");
        //         // return Promise.resolve(code);
        //     }
        // }

        this.loginManager = directLoginManagerBuilder(config, 
            sessionStorage, this.statsCollector, this.api, 
            this.detectedWebview, this, this.deviceIdProvider, 
            this.urlHandler, this.proxy, this.gsiLoader
            //,contextualControls
        );
        
       

        this.loginManager.getProviderListSync().forEach(prov => {
            if ( prov.providerId == AuthProviderIdentifier.GOOGLE_ONE_TAP && isProviderHasOneTapDelegate(prov) ) {
                prov.setOneTapDelegate(
                    new OneTapDelegateLocalImpl(this.gsiLoader)
                );
            }
        });
                
        this.sessionProxy = new CurrentSessionProxyDefaultImpl(this.loginManager);
        
        
    

        this.onReady(api => {
            this.classicQueue.resolve(api);
            if(hasOwnProperty(window, GLOBAL_FUNCTION_NAME) && isFunction(window[GLOBAL_FUNCTION_NAME])) {
                window[GLOBAL_FUNCTION_NAME](api);
            }
        });

        this.pushNotificationService = new PushNotificationService(
            this,
            this.cfgHelper.getPushNotificationHelperConfig(),
            MessagingPushNotHelperLogger,
            registerServiceWorker
        );
        
        this.listenOnUserEvents();

    }

    
    public async verificationWithOTPCode(challenge: string, code: string): Promise<OTPVerificationResponse> {
        return this.api.verificationWithOTPCode(challenge, code);
    }

    public async generateOtpChallenge(inputData: OTPLoginInputData, operation?: Ask1stPartyEmailLoginOperation) : Promise<EmailLoginAskResponse> {
        if(isOTPLoginInputData(inputData)) {
            return await this.api.ask1stPartyEmailLogin(operation ? operation : Ask1stPartyEmailLoginOperation.SIGN_UP, inputData);
        }
        else {
            return Promise.reject(new Error("Invalid OTPLoginInputData object"));
        }
    }

    public async confirmOtp(challenge: EmailLoginAskResponse, code: string): Promise<SessionObject | OTPVerificationResponse> {
        const tpud = FirstPartyEmailLogin.marshallTPUD(challenge, code);
        if(challenge.purpose == Ask1stPartyEmailLoginOperation.VERIFICATION) {
            return this.verificationWithOTPCode(challenge.challenge, code);
        }
        else return this.loginManager.loginWithTPUD(tpud, {})
    }
    

    private serverIframe;
    private iframeBaseUrlPart;

    protected serverInit() {
        this.logger.debug("Initializing server");
        this.beforeServerInit();
        
        this.proxy.register("serverReadySignal", (_ready) => {
            this.logger.debug("Got serverReadySignal ... invoking lm.start()");
            this.loginManager.start();
            return Promise.resolve(true);
        });

        (this.serverIframe.get(0) as HTMLIFrameElement).src = this.iframeBaseUrlPart + this.config.serverSdkEndpoint + "#" + encodeURIComponent(document.location.href);

        this.afterServerInit();
    }
    
    
    preloadProviders(ids: AuthProviderIdentifier[], async: boolean): Promise<void> {
        return this.loginManager.preloadProviders(ids, async);
    }
    
    
    isAutologinLocked(): Promise<boolean> {
        return this.loginManager.isAutologinLocked();
    }

    protected abstract beforeServerInit():void;
    protected abstract afterServerInit():void;
    
    
  


    _statsTrackPageview(page_title?: string, page_location?: string, other_params?: Record<string,any>): void {
        if(this.ga4StatsCollector) {
            this.ga4StatsCollector.freePageView(page_title,page_location,other_params);
        }
    }

    _statsTrackEvent(event_name: string, params?: Record<string,any>): void {
        if(this.ga4StatsCollector) {
            this.ga4StatsCollector.freeEvent(event_name,params);
        }
    }
  
    getConfig(): PropertyConfig {
        return this.config;
    }
    
    getPushService(): PushServiceInterface {
        return this.pushNotificationService;
    }

    isSubscriptionManualActivationContext(): boolean {
        return this.pushNotificationService.isSubscriptionManualActivationContext();
    }
   
    supportsPushNotifications(): boolean {
        return this.pushNotificationService.isSystemEnabled();
    }
    
    public webviewDetect(): DetectedWebView {
        return this.detectedWebview;
    }
    

    //%% SIGNIN EXTRA PARAMS SECTION
    /**
     * utilizzato per forzare l'invio della mail sul login di un account
     * @param {*} enable 
     */
    bdaySim(enable: boolean): void {
        this.signin_extra_params.enable_bsim = enable;
    }

    genderSim(gender: string): void {
        this.signin_extra_params.enable_gender_sim = gender;
    }
    //%% END OF SIGNIN EXTRA PARAMS



    //%% SPARSE METHOD SECTION
    getCurrentSession(): StorableSession {
        return this.sessionProxy.getCurrentSession();
    }

    async getCurrentSessionObject(): Promise<SessionObject> {
        const curSess = this.sessionProxy.getCurrentSession();
        if(isLoggedInSession(curSess)) {
            const lprov = await this.getLastLoginProvider();
            const bon = inEnum(lprov, AuthProviderIdentifier) ? lprov : AuthProviderIdentifier.FIRST_PARTY_EMAIL;
            return Promise.resolve(new SessionObject(curSess,{
                isNewUser: false,
                loginMode: LoginMode.SESSION,
                provider: bon
            },true));
        }
        else {
            return Promise.resolve(null);
        }
    }

    getCurrentSessionReact(): void {
        if(this.nativeapp)  {
            this.nativeapp.sessionChange(this.sessionProxy.getCurrentSession(), this.detectedWebview.platform.android?"android":"ios");           
        }
    }
    
    //%% ENDOF SPARSE METHOD SECTION



    private forceProxyUpdate(sobj: SessionObject, loginMode: boolean): SessionObject {
        if(loginMode) {
            if(sobj && sobj.session && sobj.session.role == UserRole.AUTHENTICATED_USER) {
                // @task #10188 - preemptive proxy setting
                this.sessionProxy.updateSession(sobj.session);
                
            }
        }
        else this.sessionProxy.updateSession(sobj && sobj.session?sobj.session:null);
        
        return sobj;
    }


    loginWithTPUD(tpud: ThirdPartyCientAuthData, extra_params: any): Promise<SessionObject> {
        const rPromise = this.loginManager.loginWithTPUD(tpud, extra_params);
        return rPromise.then(sobj => {
            return this.forceProxyUpdate(sobj, true);
        });
    }

    //%% DELEGATE SECTION

    //%% login manager delegates
    login(providerId: AuthProviderIdentifier, extra_params: any, customParams: PrompLoginCustomParameters = null): Promise<SessionObject> {
        let rPromise: Promise<SessionObject | OTPVerificationResponse> = Promise.resolve(null);
        if(providerId != AuthProviderIdentifier.FIRST_PARTY_EMAIL) {
            if(this.detectedWebview.native_app) {
                if(this.nativeAppFeatures.isMultipleLoginSupported()) {
                    const waitFor = this.loginManager.getNativeAppLoginPromise();
                    rPromise = this.nativeapp.requireLogin(providerId).then(response => {
                        /**
                         * #13144 - questo metodo, da quando abbiamo delegato la 
                         * responsabilità allo sdk di chiamare, anche nel caso delle app native,
                         * il signIn (chiamato dall'app nella forma di LoginManager.nativeAppSignIn)
                         * questo sovrascrive con dati non validi la sessione reale
                         */ 
                        if(this.nativeAppFeatures.handlesLoginOnClientSide()) {
                            return waitFor;
                        }
                        else {
                            if(response && response.token) {
                                return this.loginManager.nativeAppSetSessionWithProvider(response.lastLoginProvider, response.token, NativeAppSetSessionCause.LOGIN, !!response.isNewUser);                      
                            }
                            else return Promise.resolve(null);
                        }
                    });
                }
                else {
                    this.nativeapp.requireFacebookLogin();
                }
            }
            else {

                const useParams = extra_params?{
                    ...extra_params,
                    ...this.signin_extra_params
                }:this.signin_extra_params;

                rPromise = this.loginManager.login(providerId, useParams, customParams);
            }
        }
        else {
            rPromise = this.emailLoginGUIFlow(extra_params, customParams);
        }
        
        return rPromise.then(sobj => {
            if(sobj instanceof SessionObject) {
                return this.forceProxyUpdate(sobj, true);
            }
            else return Promise.reject(new Error("Invalid operation (verification) could not sign in/up" ));
        });
    }

    public async emailLoginGUIFlow(extra_params: any, customParams: PrompLoginCustomParameters): Promise<SessionObject | OTPVerificationResponse> {
        if(this.config.loginManager.actual_providers.email.codeLoginAllowed) {
            const guictl = await this.getSharedGuiControls();
            return guictl.otpLoginProcedure({email: customParams?.email, redirect_uri: customParams?.returnUri}, this, Ask1stPartyEmailLoginOperation.SIGN_UP);
        }
        else {
            const useParams = extra_params?{
                ...extra_params,
                ...this.signin_extra_params
            }:this.signin_extra_params;
            return this.loginManager.login(AuthProviderIdentifier.FIRST_PARTY_EMAIL, useParams, customParams);
        }
        
    }

    getProviderList(): Promise<AuthProviderIdentifier[]> {
        return this.loginManager.getProviderList();
    }

    logout(): Promise<void> {
        if(this.detectedWebview.native_app) {
            try {
                this.nativeapp.logoutExecuted();
            } 
            catch(e) {
                this.logger.error("Error notifying nativeapp of executed logout", e);
            }
        }
        return this.loginManager.logout().then(_x => this.forceProxyUpdate(null, false)).then(
            () => {
                if (this.config?.membership?.enable) {
                    return fetch("/membership/reauth/logoutrest", { credentials: 'same-origin' });
                }
            }
        ).then();

    }

    thereWasASession(): Promise<boolean> {
        return this.sessionProxy.thereWasASession();
    }

    nativeAppSetSession(tok: string): void {
        this.loginManager.nativeAppSetSession(tok);
    }

    nativeAppSetSessionWithProvider(provider: AuthProviderIdentifier, token: string, cause: NativeAppSetSessionCause, isNewUser: boolean = false): void {
        this.loginManager.nativeAppSetSessionWithProvider(provider, token, cause, isNewUser);
    }

    nativeAppSetTrackingOptOut(v: boolean): void {
        this.logger.debug("nativeAppSetTrackingOptOut called ", v);
        this.setTrackingOptOut(v);
    }

    collectStatNotificationOpen() {
        this.statsCollector.iosNotificationOpen();
    }

    nativeAppSignIn(token: string, tuple: ThirdPartyCientAuthDataInterface) {
        return this.loginManager.nativeAppSignIn(token, ThirdPartyCientAuthData.FromInterface(tuple));
    }

    checkIfSessionChanged(): Promise<SessionObject> {
        this.logger.log("checkIfSessionChanged called");
        return this.loginManager.checkIfSessionChanged();
    }

    loginOrAutologin(providerId: AuthProviderIdentifier, customParams: PrompLoginCustomParameters): Promise<SessionObject> {
        return this.loginManager.loginOrAutologin(providerId, customParams).then(x => this.forceProxyUpdate(x, true));
    }

    doOneTapLogin(providerId: AuthProviderIdentifier, _extra_params: any): Promise<SessionObject> {
        return this.loginManager.doOneTapLogin(providerId, this.signin_extra_params).then(x => this.forceProxyUpdate(x, true));
    }

    dPD(checkField: string): Promise<DataDeletionInfo> {
        return this.loginManager.dPD(checkField).then(x => {
            if(x && x.confirmation_code) {
                if(this.detectedWebview.native_app) {
                    try {
                        this.nativeapp.personalDataDeletionCompleted();
                    }
                    catch(e) {
                        this.logger.error("Error notifying nativeapp of personal data deletion", e);
                    }
                }
            }
            return x;
        });           
    }

    protected isServerReady(): Promise<boolean> {
        return this.proxy.invoke("isServerReady");
    }

    getLastLoginProvider(): Promise<string> {
        return this.loginManager.getLastLoginProvider();
    }
    //%% rest methods
    follow(queryObj: TopicQueryObj, extra_info: UserActionExtraInfo | null): Promise<Response<FollowResponseObject>> {
        return this.api.follow(queryObj, extra_info);
    }
    unfollow(queryObj: TopicQueryObj, extra_info: UserActionExtraInfo | null): Promise<Response<FollowResponseObject>> {
        return this.api.unfollow(queryObj, extra_info);
    }
    checkFollowedTopics(checkReq: TopicFollowCheckRequest): Promise<Response<TopicFollowCheckResponse>> {
        return this.api.checkFollowedTopics(checkReq);
    }
    getUserFollowedTopics(): Promise<Response<GroupedResolvedTopicObjs>> {
        return this.api.getUserFollowedTopics();
    }


    subscribeNewsletter(queryObj: TopicQueryObj, extra_info: UserActionExtraInfo | null): Promise<Response<TopicObj>> {
        return this.api.subscribeNewsletter(queryObj,extra_info);
    }
    unsubscribeNewsletter(queryObj: TopicQueryObj, extra_info: UserActionExtraInfo | null): Promise<Response<TopicObj>> {
        return this.api.unsubscribeNewsletter(queryObj,extra_info);
    }
    removeNewsletter(queryObj: TopicQueryObj, extra_info: UserActionExtraInfo | null): Promise<Response<TopicObj>> {
        return this.api.removeNewsletter(queryObj,extra_info);
    }
    listNewsletterSubscriptions(): Promise<Response<TopicObj[]>> {
        return this.api.listNewsletterSubscriptions();   
    }
    checkNewsletterSubscriptions(checkReq: TopicSubscriptionCheckRequest): Promise<Response<TopicSubscriptionCheckResponse>> {
        return this.api.checkNewsletterSubscriptions(checkReq);
    }


    getRecommended(skip: number, limit: number): Promise<Response<RecommendedResponse>> {
        return this.api.getRecommended(skip, limit);
    }
    getRecommendedCount(): Promise<Response<RecommendedCount>> {
        return this.api.getRecommendedCount();
    }
    registerDevice(deviceReq: DeviceUpdateRequestPayload): Promise<Response<SubscriptionListResponse>> {
        return this.api.registerDevice(deviceReq);
    }
    unregisterDevice(deviceReq: DeviceOrientedRequest): Promise<Response<SubscriptionListResponse>> {
        return this.api.unregisterDevice(deviceReq);
    }

    enableDevice(deviceReq: DeviceOrientedRequest): Promise<Response<SubscriptionListResponse>> {
        return this.api.enableDevice(deviceReq);
    }
    disableDevice(deviceReq: DeviceOrientedRequest): Promise<Response<SubscriptionListResponse>> {
        return this.api.disableDevice(deviceReq);
    }
    listDevices(): Promise<Response<SubscriptionListResponse>> {
        return this.api.listDevices();
    }

    checkSavedArticles(checkReq: BookmarkCheckRequest): Promise<Response<BookmarkCheckResponse>> {
        return this.api.checkSavedArticles(checkReq);
    }
    bookmark(q: BookmarkQueryObj, extra_info: UserActionExtraInfo | null): Promise<Response<BookmarkCheckResponse>> {
        return this.api.bookmark(q, extra_info);
    }
    unbookmark(q: BookmarkQueryObj, extra_info: UserActionExtraInfo | null): Promise<Response<BookmarkCheckResponse>> {
        return this.api.unbookmark(q, extra_info);
    }
    getSavedArticles(): Promise<Response<BookmarkedContentsResponse>> {
        const session = this.sessionProxy.getCurrentSession();
        if(session && session.role == UserRole.AUTHENTICATED_USER) {
            return this.api.getSavedArticles();
        }
        else return Promise.resolve(Response.OK({ contents:[] }));
    }
    getMyPage(): Promise<Response<any>> {
        return this.api.getMyPage();
    }
    getMyMenu(): Promise<Response<any>> {
        return this.api.getMyMenu();
    }
    getSlider(sliderName: string, href?: string): Promise<Response<any>> {
        return this.api.getSlider(sliderName, href);
    }

    resolve(url: string): Promise<Response<FullContent>> {
        return this.api.resolve(url);
    }
    apiFreeCall(url: string): Promise<Response<any>> {
        return this.api.apiFreeCall(url);
    }
    getMe(full_data: boolean): Promise<Response<UserFullInfo, any>> {
        return this.api.getMe(full_data).then(resp => {
            const age = resp.data?.user_info?.age?resp.data.user_info.age:-1;
            const ug = resp.data?.user_info?.sex?resp.data.user_info.sex:UserGender.UNKNOWN;
            const membershipAnaInfo = hasOwnProperty(resp.data, "membership_type")  ? {
                membership_type: "" + resp.data.membership_type,
                membership_status: !!resp.data.membership_status
            } : undefined;
            this.statsCollector.markUserPersInfo(age, ug, membershipAnaInfo);
            return resp;
        });

    }
    getMembershipStatusInfo(): Promise<MembershipStatusInfo> {
        return this.api.getMembershipStatusInfo();
    }

    updatePersonalData(upd: OnUserUpdateData): Promise<Response<OnLoginResponse, any>> {
        return this.api.updatePersonalData(upd);
    }

    becomeMember(): Promise<Response<any, any>> {
        return this.api.becomeMember();
    }

    memberInfo(): Promise<Response<any, any>> {
        return this.api.memberInfo();
    }

    isMember(): Promise<boolean> {
        return this.api.memberInfo().then(
            () => true
        ).catch(
            () => false
        );
    }

    isUnloggedMember(): Promise<boolean> {
        return this.getMe(true).then(
            (res) => {
                return res.data.isUnloggedMember === true;
            }
        ).catch(
            () => false
        );
    }

    hasMembershipBillingItems(): Promise<boolean> {
        return this.getMe(true).then(
            (res) => {
                return res.data.hasMembershipBillingItems === true;
            }
        ).catch(
            () => false
        );
    }
    

    ask1stPartyEmailLogin(operation: Ask1stPartyEmailLoginOperation, data: Ask1stPartyEmailAuthData): Promise<EmailLoginAskResponse> {
        return this.api.ask1stPartyEmailLogin(operation,data);
    }

    getEventPlatformToken(): Promise<string> {
        if (isLoggedInSession(this.sessionProxy.getCurrentSession())) {
            return this.api.getEventPlatformToken();
        }
        else {
            return Promise.reject("Not logged");
        }
    }

   
    // %% personal data methods section
    setWizardCompleted(): void {
        this.personalDataStorage.setWizardCompleted();
    }
    isWizardCompleted(): Promise<boolean> {
        return this.personalDataStorage.isWizardCompleted();
    }
    setNotificationsUnsubscribed(): void {
        this.personalDataStorage.setNotificationsUnsubscribed();
    }
    unsetNotificationsUnsubscribed(): void {
        this.personalDataStorage.unsetNotificationsUnsubscribed();
    }
    isNotificationsUnsubscribed(): Promise<boolean> {
        return this.personalDataStorage.isNotificationsUnsubscribed();
    }
    setCTALastShowed(): void {
        this.personalDataStorage.setCTALastShowed();
    }
    setSexAndRange(sar: string): void {
        this.personalDataStorage.setSexAndRange(sar);
    }
    getCTALastShowed(): Promise<number> {
        return this.personalDataStorage.getCTALastShowed();
    }

    retrieveOrGenerateDeviceId(): Promise<DeviceIdInfo> {
        return this.deviceIdProvider.retrieveOrGenerateDeviceId();
    }
    setTrackingOptOut(v: boolean): Promise<void> {
        return this.personalDataStorage.setTrackingOptOut(v);
    }
    getTrackingOptOut(): Promise<boolean> {
        return this.personalDataStorage.getTrackingOptOut();
    }

    

    // %%ENDOF DELEGATE SECTION
    
    // %% Shatsu Delegated Methods

    niceDateFormat(d: Date|string|number, locale: CatalogueLanguages = CatalogueLanguages.it): string  {
        return niceDateFormat(d, locale);
    }

    // %% ENDOF Shatsu Delegated Methods

    

    
    //%%ENDOF DELEGATE SECTION

    public loginModeSupported() {
        return "multi";
    }

    public getUnreadNotifications(): Promise<number> {
        const session = this.sessionProxy.getCurrentSession();
        if(session && session.role == UserRole.AUTHENTICATED_USER) {
            return this.getRecommendedCount().then(res => res.data.count);
        }
        else return Promise.resolve(2);
    }


    private listenOnUserEvents() {
        this.api.onUserTopicFollowAction((query) => {
            this.statsCollector.collectTopicActionData(query.extra_info?.source_element, query.followed ? TopicAction.FOLLOW : TopicAction.UNFOLLOW, query.url ? query.url : "UNRESOLVED");
        });

        this.api.onUserNewsletterSubscribeAction((query) => {
            this.statsCollector.collectTopicActionData(query.extra_info?.source_element, query.subscribed ? NewlsetterAction.SUBSCRIBE : NewlsetterAction.UNSUBSCRIBE , query.url ? query.url : "UNRESOLVED");
        })

        this.api.onUserArticleSaveAction((query) => {
            this.statsCollector.collectBookmarkActionData(query.extra_info?.source_element, query.saved ? BookmarkAction.BOOKMARK : BookmarkAction.UNBOOKMARK, isBookmarkQueryByUrl(query.query) ? query.query.url : "UNRESOLVED");
        });

        this.api.onDeviceSubscriptionChange((details) => {
            this.statsCollector.collectDeviceActionData(details.action, getStatDeviceTypeFromNotificationDeviceType(details.device));
        });
    }
    

    public redirectToMembershipBuyPage() {
        this.api.getMembershipBuyLink().then( link => window.location.href = link );
    }

    public redirectToMembershipGiftPage() {
        this.api.getMembershipGiftLink().then( link => window.location.href = link );
    }

    public redirectToRedeemGiftPage(subscriptionId: string, userId: string, checkId: string) {
        this.api.getRedeemGiftLink(subscriptionId, userId, checkId).then( link => window.location.href = link );
    }

    public redirectToMembershipManagementPage(sub: string = null, newTab: boolean = false) {
        this.api.getMembershipManagementLink(sub).then( link => newTab ? window.open(link) : window.location.href = link );
    }
    public getMembershipManagementLink(sub: string = null): Promise<string> {
        return this.api.getMembershipManagementLink(sub);
    }

    public redirectToDirectProductBuyPage(type: MembershipType, options: BuyMembershipOptions = {}) {
        
        this.api.getDirectBuyLink(type, options).then( link => {
            if (options.newTab) {
                window.open(link, '_blank').focus();
            }
            else {
                window.location.href = link;
            }
        } );
    }


    loginRequested(): boolean {
        if(this.config?.membership?.enable && window.location.hash && this.isLanding()) {
            const hash = window.location.hash.substring(1);
            this.logger.debug("Detected hash ", hash);
            
            return hash.split("|").filter( x => !!x.match(new RegExp("^"+API_LOGIN_HASH+"$")) ).length > 0;
        }
        else {
            return false;
        }
    }

    private isLanding(): boolean {
        return this.config?.membership && this.config?.membership?.enable && 
                    this.config.membership.landingUrl == (window.location.protocol + "//" + window.location.hostname + window.location.pathname).replace(/\/+$/, "");
    }

    public getStatsCollector(): StatsCollector {
        return this.statsCollector;
    }




    protected async internalShowMailLoginDialog(isFix: boolean,
        sourceIntent: UserActionIdentifier,
        options?: {
            cta?: CTAStatsDetails
        }
        
    ): Promise<Ask1stPartyEmailAuthData> {
            const collectAction = options?.cta?.action && inEnum(options.cta.action,CTA_NAME)?options.cta.action:null;
        if(collectAction) {
            this.statsCollector.collectCTAData({
                action: collectAction,
                outcome: CTA_OUTCOME.SHOWN,
                source_element: options?.cta?.source_element?options?.cta?.source_element:"unspecified",
                topic: options?.cta?.topic
            });
        }

        const gui = await this.getSharedGuiControls();
        let data;
        if (isFix) {
            const me = await this.getMe(false)
            data = {
                email: me.data.email,
                firstName: me.data.nameAndGender.first_name,
                lastName: me.data.nameAndGender.last_name
            }
        }
        return  new Promise((resolve,reject) => {
            const submit: (d: Ask1stPartyEmailAuthData) => void  = (d) => {
                resolve(d);
            }; 
            const closeFn = () => {
                reject();
            }
            gui.generateEmailFixDialog(isFix, sourceIntent, data, submit, options?.cta?.topic, closeFn);
        })
        
        
    }


}